import React from "react";
import Button from "../components/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateScreenAction, resetAction } from "../actions";

function MoreInformation({ screens, reset }) {
  return (
    <div>
      <div id={"step-8"} className="uk-text-center c-quiz">
        <h1 className="c-quiz_head">Pump Selector Tool</h1>
        <h2 className="c-quiz__question">We need some more information</h2>
        <div style={{ marginTop: "40px" }}>
          <h4 className="c-quiz_description">
            We need some more information based on your selection.
          </h4>
          <h4 className="c-quiz_description">
            Please complete this online form which will be sent to your chosen
            Reece Irrigation & Pools Branch.
          </h4>
        </div>

        <div className="c-quiz_button-wrapper">
          <Button
            text="go to form"
            secondary={false}
            fixedWidth
            onClick={() => {
              window.open("https://form.typeform.com/to/OOHGhiWn");
            }}
          />
          <Button
            text="start again"
            icon="redo-solid"
            fixedWidth
            secondary={true}
            onClick={() => {
              reset();
            }}
          />
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      reset: resetAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(MoreInformation);
